import RecipeStep from 'records/RecipeStep';
import Base from 'records/Base';

import {
  RECIPE_STEP_ASYNC_ACTION_START,
  RECIPE_STEP_ASYNC_ACTION_ERROR,
  RECIPE_STEP_ASYNC_UPDATE_ACTION_SUCCESS,
  RECIPE_STEP_ASYNC_ARCHIVE_ACTION_SUCCESS,
  RECIPE_STEP_RESET_STATE,
} from 'actions/recipeStep';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new RecipeStep(),
});

const actionsMap = {
  [RECIPE_STEP_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECIPE_STEP_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECIPE_STEP_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new RecipeStep(action.data),
    });
  },
  [RECIPE_STEP_ASYNC_ARCHIVE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new RecipeStep(),
    });
  },
  [RECIPE_STEP_RESET_STATE]: () => {
    return initialState;
  },
};

export default function recipeStep(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
